import { render, staticRenderFns } from "./DataVerificationFeatureCarousel.vue?vue&type=template&id=0d3cd5d0&"
import script from "./DataVerificationFeatureCarousel.vue?vue&type=script&lang=js&"
export * from "./DataVerificationFeatureCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports